import styled from "@emotion/styled"
import { NavigationItemContainerBase } from "components/NavigationItem/style"

export const StyledTapBarItem = styled.div``

export const StyledIconContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(0.5)};
  text-align: center;
  svg {
    display: block;
    width: 2.4rem;
    height: 2.4rem;
  }
`

export const NavigationItemContainer = styled(NavigationItemContainerBase)`
  flex: 1;
  padding: ${({ theme }) => theme.spacing(1)};
`
